<template>
    <div>
        <h1>RENJA EVALUASI KEGIATAN</h1>
    </div>
</template>

<script>
export default {

}
</script>

<style>

</style>
